import { Component, inject } from '@angular/core';
import {
  CoreButton,
  CoreIcon,
} from "@svs/angular";
import { AuthService } from "../../../@core/auth/auth.service";

@Component({
  selector: 'app-offline-disclaimer',
  imports: [
    CoreIcon,
    CoreButton,
  ],
  templateUrl: './offline-disclaimer.component.html',
  styleUrl: './offline-disclaimer.component.css'
})
export class OfflineDisclaimerComponent {
  authService = inject(AuthService);
}
